
<template>
    <div class="login_container">
        <div class="top">
            <div>登录入口</div>
        </div>
        <div class='login_box'>
            <div class="login">管理员登陆</div>
            <!-- <div class='avatar_box'>
                <img src="../assets/log/logo.png" alt="">
            </div> -->

            <!--登录表单区-->
            <!-- <div class='login_box2'> -->
            <el-form class='login_box2' :rules="loginFormRoules" ref="loginFormRef" :model="loginForm" label-width="0px">

                <el-form-item label="" prop="username">
                    <el-input v-model="loginForm.username"> <i slot="prefix" class="iconfont">&#xe56f;</i></el-input>
                </el-form-item>
                <el-form-item label="" prop="password">
                    <el-input v-model="loginForm.password" type="password"><i slot="prefix"
                            class="iconfont">&#xe56c;</i></el-input>
                </el-form-item>
                <el-form-item class='btns'>
                    <el-button type="primary" @click="login">登录</el-button>
                    <el-button type="info" @click="resetLoginForm">重置</el-button>
                </el-form-item>
            </el-form>
            <!-- </div> -->
        </div>
        <div class="buttom">
            <div>版权所有：{{  copyright }} </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            copyright: '',
            loginForm: {
                C_type: 'Admin_login',
                username: 'admin',
                password: '123456'
            },
            loginFormRoules: {
                username: [
                    { required: true, message: '请输入登录名称', trigger: 'blur' },
                    { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在6 个字符以上', trigger: 'blur' }
                ]
            },
            created() {
                window.console.log(123)
                console.log(123)
            }
        }
    },
    created() {
        this.copyright = 'mello'
        window.sessionStorage.setItem('copyright', this.copyright)
        window.sessionStorage.setItem('tokenUserType', 2) // 写入登录用户的类型 2 为管理员 
    },
    methods: {
        // 点击重置登录按钮
        resetLoginForm() {
            // console.log(this)
             
            this.$refs.loginFormRef.resetFields()
        },

        login() {
            this.$refs.loginFormRef.validate(async (valid) => { // 表单预校验
                //  console.log(valid)
                if (!valid) return;
                // var params = new URLSearchParams()
                // 参数保存
                // const result = await this.$http.post('api', this.loginForm)
                // console.log(result)
                const { data: res } = await this.$http.post('api', this.loginForm)
                // awit 只能用在被async修饰都方法中，用来简化 promise返回的数据
                // data: res  解构 返回数据中的data对象，然后重新赋值给res
                // 对象解构用{}，变量解构用[]
                //   console.log(res.Admin_test_Flag)
                if (res.Admin_test_Flag !== 1) return this.$message.error('登录失败！')
                this.$message.success('登陆成功')
                // const token = res.token // 该torken 用来读取其他出登录api之外的接口 ，保存在sessionStorage
                // console.log(token)
                window.sessionStorage.setItem('token', res.token)
                window.sessionStorage.setItem('qiye_mob', 'admin')
                // window.sessionStorage.setItem('yonghu_type', 1)
                window.sessionStorage.setItem('tokenUserType', 2) // 写入登录用户的类型 2 为管理员
                
                this.$router.push('/yunying/chanpin') // 直接导航到 需要的页面
            })
        }
    }
};
</script>
<style lang="less" scoped>
.login_container {
    background-color: #292929;
    width: 100%;
    height: 100%;
    // background: url("../assets/img/bgAdmin.jpg") no-repeat;
    background-size: 100% 100%;
    background-attachment: fixed;
}

.login_box {
    width: 380px;
    height: 300px;
    background-color: white;
    border-radius: 6px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.qiye {
    width: 300px;
    height: 130px;
    border-radius: 50%;
    padding: 10px;
    font-size: 30px;
    position: absolute;
    color: #444;
    font-weight: 4030;
    left: 50%;
    transform: translate(-40%, -90%);

}

.avatar_box {
    width: 130px;
    height: 130px;
    border: 1px solid #eee;
    border-radius: 50%;
    padding: 10px;
    box-shadow: 0 0 10px #ddd;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;

    img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: #eee;
    }
}

.login_box2 {
    padding-top: 50px;
    position: absolute;
    bottom: 0px;
    padding: 0 20px;
    box-sizing: border-box;
    width: 100%;
}

.btns {
    display: flex;
    justify-content: flex-end;
}

.title_pzeiot {
    padding-top: 120px;
    padding-left: 85px;

}

.top {
    background: #2b2f3a;
    color: #fff;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    //  font-weight: 500;

}

.buttom {
    background: #fff;
    color: #2b2f3a;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    //  font-weight: 500;
    font-size: small;
    bottom: 0px;
    position: fixed;
    width: 100%;
}

.login {
    text-align: center;
    display: flex;
    background-color: #2b2f3a;
    border-radius: 5px 5px 0px 0px;
    height: 60px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: large;
    color: antiquewhite;

}</style>
